import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.84 17.62L24.52 5.21A2 2 0 0022.68 4H9.32a2 2 0 00-1.84 1.21L2.16 17.62a2.1 2.1 0 00-.16.79V26a2 2 0 002 2h24a2 2 0 002-2v-7.59a1.92 1.92 0 00-.16-.79zM28 26H4v-7.59L9.32 6h13.36L28 18.41z"/><path d="M20.59 20h-9.18l-1.56-1.57A1.5 1.5 0 008.79 18H7a1 1 0 000 2h1.59l1.56 1.57a1.49 1.49 0 001.06.43h9.58a1.49 1.49 0 001.06-.43L23.41 20H25a1 1 0 000-2h-1.79a1.5 1.5 0 00-1.06.44zm-11.8 0z"/>';
export var InboxOutlineSVG = function InboxOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
InboxOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(InboxOutlineSVG);